import "antd/lib/card/style";
import _Card from "antd/lib/card";
import "antd/lib/row/style";
import _Row from "antd/lib/row";
import "antd/lib/col/style";
import _Col from "antd/lib/col";
import _classCallCheck from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _defineProperty from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "antd/lib/date-picker/style";
import _DatePicker from "antd/lib/date-picker";
import "antd/lib/select/style";
import _Select from "antd/lib/select"; /*@客户-分时流量*/
import React from 'react';
import './index.scss';
import moment from "moment";
import BossPieCharts from "../../Common/Charts/Pie/BossPieCharts";
import BossBarChart from "../../Common/Charts/Bar/BossBarChart";
import { injectIntl } from "react-intl";
import BossHeaderChoose from '../../Common/BossHeaderChoose';
import FlowInfoForNoDpi from '../CI2802/DeviceDetailModal/Tab-FlowInfo/FlowInfoForNoDpi';
import noWan from '../../../assets/img/noWan.png';
var Option = _Select.Option;
var RangePicker = _DatePicker.RangePicker;
var CI0302 = /*#__PURE__*/function (_React$Component) {
  _inherits(CI0302, _React$Component);
  function CI0302(props) {
    var _this;
    _classCallCheck(this, CI0302);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(CI0302).call(this, props));
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "get_steps_beta", function () {
      _this.props.dispatch({
        type: "ci0302Info/get_rtt_data",
        payload: {
          item: "steps",
          companyid: _this.state.company_id,
          start_tm: _this.state.start_tm,
          end_tm: _this.state.end_tm,
          top: 1000
        }
      }).then(function () {
        _this.setState({
          showBarChart: false,
          showDetail: false,
          barChartData: []
        });
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "selectTimeIntervalA", function (value) {
      var start_tm_temp = "";
      var end_tm_temp = moment().format("YYYY-MM-DD HH:mm:ss");
      switch (value) {
        case "0":
          start_tm_temp = moment().subtract(30, "minutes").format("YYYY-MM-DD HH:mm:ss");
          break;
        case "1":
          start_tm_temp = moment().subtract(6, "hours").format("YYYY-MM-DD HH:mm:ss");
          break;
        case "2":
          start_tm_temp = moment().subtract(24, "hours").format("YYYY-MM-DD HH:mm:ss");
          break;
        case "3":
          start_tm_temp = moment().subtract(7, "days").format("YYYY-MM-DD HH:mm:ss");
          break;
        case "4":
          start_tm_temp = moment().subtract(1, "months").format("YYYY-MM-DD HH:mm:ss");
          break;
        default:
          start_tm_temp = moment().subtract(30, "minutes").format("YYYY-MM-DD HH:mm:ss");
      }
      _this.setState({
        start_tm: start_tm_temp,
        end_tm: end_tm_temp
      }, function () {
        _this.get_steps_beta();
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "disabledDate", function (current) {
      return current.diff(_this.state.start_tm, 'days') < -5 || current.diff(_this.state.start_tm, 'days') > 6;
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleRangeChange", function (moment) {
      if (moment.length === 1) {
        _this.setState({
          start_tm: moment[0].format("YYYY-MM-DD HH:mm:ss")
        });
      } else if (moment.length === 2) {
        _this.setState({
          start_tm: moment[0].format("YYYY-MM-DD HH:mm:ss"),
          end_tm: moment[1].format("YYYY-MM-DD HH:mm:ss")
        }, function () {
          _this.get_steps_beta();
        });
      }
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "clickPieChart", function (e) {
      _this.setState({
        showBarChart: true,
        barChartData: e.data.search,
        barColor: e.color,
        showDetail: false
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "get_device_list", function (sn) {
      _this.props.dispatch({
        type: "ci0302Info/get_device_list",
        payload: {
          company_id: _this.state.company_id,
          name: sn
        }
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "clickBarChart", function (e) {
      _this.get_device_list(e.data.search);
      _this.setState({
        showDetail: true,
        detailData: e.data
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleSearchCompany", function (value, name) {
      _this.setState({
        company_id: value || "",
        company_name: name || ""
      }, function () {
        _this.get_steps_beta();
      });
    });
    _this.state = {
      start_tm: moment().subtract(30, "minutes").format("YYYY-MM-DD HH:mm:ss"),
      end_tm: moment().format("YYYY-MM-DD HH:mm:ss"),
      timeInterval: "",
      data_num: 5,
      appName: "",
      company_id: sessionStorage.getItem('companyId') || "",
      barChartData: [],
      showBarChart: false,
      barColor: ''
    };
    _this.isCustom = sessionStorage.getItem("role") === "companystaff" || sessionStorage.getItem("role") === 'company';
    _this.isJSZC = sessionStorage.getItem("role") === "supercxptechsupport" || sessionStorage.getItem("role") === "supercxptechadmin";
    return _this;
  }
  _createClass(CI0302, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.isCustom) {
        this.get_steps_beta();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var dateFormat = 'YYYY-MM-DD HH:mm:ss';
      var barChartData = this.state.barChartData;
      var stepsebtaData = this.props.ci0302Info.stepsebtaData;
      if (barChartData.length < 5) {
        for (var i = barChartData.length; i < 5; i++) {
          barChartData.push({
            name: "There is currently no data available",
            value: '0'
          });
        }
      }
      var flowPieChartProps = {
        id: 'flowPieChartForAll',
        containerWidth: '100%',
        containerHeight: '300px',
        onClick: function onClick(e) {
          return _this2.clickPieChart(e);
        },
        option: {
          title: {
            text: "Flow distribution"
          },
          legend: {
            orient: 'vertical',
            type: 'scroll',
            right: '10%',
            top: '10%',
            data: stepsebtaData.map(function (item) {
              return item.name;
            })
          },
          series: [{
            name: "flow",
            type: 'pie',
            data: stepsebtaData,
            center: ['30%', '50%'],
            radius: ['50%', '70%'],
            avoidLabelOverlap: false,
            label: {
              normal: {
                show: false,
                position: 'center'
              },
              emphasis: {
                show: false,
                textStyle: {
                  fontSize: '30',
                  fontWeight: 'bold'
                }
              }
            },
            labelLine: {
              normal: {
                show: false
              }
            }
          }]
        }
      };
      var bossbarchartProps = {
        id: 'deviceTopBar',
        containerHeight: 274,
        containerWidth: '100%',
        onClick: function onClick(e) {
          return _this2.clickBarChart(e);
        },
        option: {
          grid: {
            x: 50
          },
          title: [{
            text: "Traffic Ranking (M)",
            padding: [0, 0, 24, 0],
            x: 0,
            textStyle: {
              fontSize: 20,
              color: "#333",
              fontWeight: 500
            }
          }],
          // dataZoom: {
          //     type: 'slider',
          //     show: true,
          //     yAxisIndex: [0],
          //     width:18
          // },
          dataZoom: {
            show: barChartData.length > 5,
            start: 0,
            end: barChartData.length > 5 ? 4 / barChartData.length * 100 : 100
          },
          color: this.state.barColor,
          xAxis: {
            type: 'category',
            axisTick: {
              alignWithLabel: true
            },
            data: barChartData.map(function (item) {
              return item.name;
            }),
            axisLabel: {
              rotate: 30
            }
          },
          yAxis: {
            // axisLabel: {
            //     rotate: 40,
            // },
            type: 'value'
          },
          series: {
            type: 'bar',
            barMaxWidth: 32,
            data: barChartData // label: {
            //     normal: {
            //         show: true,
            //         position: 'right',
            //         color: '#333',
            //         fontWeight: 400,
            //         fontSize: 14,
            //         formatter: '{@score}MB'
            //     }
            // },
          }
        }
      };
      var nodata = stepsebtaData.filter(function (item) {
        return item.value > 0;
      }).length > 0;
      return /*#__PURE__*/React.createElement("div", null, !this.isCustom ? /*#__PURE__*/React.createElement(BossHeaderChoose, {
        onChange: this.handleSearchCompany
      }) : '', /*#__PURE__*/React.createElement(_Card, {
        className: "card"
      }, /*#__PURE__*/React.createElement("header", {
        style: {
          marginBottom: 16
        }
      }, /*#__PURE__*/React.createElement(_Select, {
        placeholder: "Please select a time interval",
        style: {
          width: 200,
          marginRight: 8
        },
        className: "input",
        onChange: this.selectTimeIntervalA,
        defaultValue: "0"
      }, /*#__PURE__*/React.createElement(Option, {
        value: "0"
      }, "Last 30 minutes"), /*#__PURE__*/React.createElement(Option, {
        value: "1"
      }, "Last 6 hours"), /*#__PURE__*/React.createElement(Option, {
        value: "2"
      }, "Last Day"), /*#__PURE__*/React.createElement(Option, {
        value: "3"
      }, "Last week")), /*#__PURE__*/React.createElement(RangePicker, {
        style: {
          width: 350,
          marginRight: 8
        },
        showTime: true,
        value: [moment(this.state.start_tm, dateFormat), moment(this.state.end_tm, dateFormat)],
        disabledDate: this.disabledDate,
        onCalendarChange: this.handleRangeChange
      })), /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement(_Row, null, /*#__PURE__*/React.createElement(_Col, {
        span: 10
      }, nodata ? /*#__PURE__*/React.createElement(BossPieCharts, flowPieChartProps) : /*#__PURE__*/React.createElement("div", {
        style: {
          textAlign: 'center'
        }
      }, /*#__PURE__*/React.createElement("img", {
        src: noWan,
        alt: "\u6682\u65E0\u6570\u636E"
      }))), /*#__PURE__*/React.createElement(_Col, {
        span: 14
      }, this.state.showBarChart ? /*#__PURE__*/React.createElement(BossBarChart, bossbarchartProps) : ''))), this.state.showDetail ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h5", {
        style: {
          fontSize: 18,
          fontWeight: 'bold'
        }
      }, "Device traffic details:", this.props.ci0302Info.deviceData.name), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FlowInfoForNoDpi, {
        sn: this.state.detailData.search || '',
        company_id: this.state.company_id,
        start_tm: this.state.start_tm,
        end_tm: this.state.end_tm,
        noTimeChange: true,
        aflow: this.state.detailData.value
      }))) : ""));
    }
  }]);
  return CI0302;
}(React.Component);
export default injectIntl(CI0302);